
import React, { useEffect } from 'react';
import {Link} from 'react-router-dom';
import AOS from 'aos';
import "aos/dist/aos.css";




function Caution() {
    useEffect(() => {
        AOS.init({
            duration: 1500
        });
    }, []);
    return (
        <React.Fragment>
            <div className="w-full h-auto pb-12 md:h-56 bg-white flex flex-col justify-center p-8">
                <h5 className="text-primary-theme text-3xl font-semibold text-center">Get started now to develop your business.</h5>

                <div className="btn-container mt-5 flex justify-center items-center flex-col md:flex-row rounded">
                    <Link to="/register">
                    <button className="btn-register2 rounded text-sm shadow">
                        REGISTER NOW
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="white" />
                        </svg>
                    </button>
                    </Link>
                    <Link to="/get-started">
                        <button className="explore-btn2 px-8 py-3 border border-gray-700 text-sm font-medium rounded shadow">EXPLORE DOCS</button>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Caution
